import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuDirections, MenuItem } from '@bruisedears/app-lib'
import { handsetBottomMenuData } from '../../../data/menus/handset-bottom-menu-data';

@Component({
  selector: 'app-handset-layout',
  imports: [RouterModule],
  templateUrl: './handset-layout.component.html',
  styleUrl: './handset-layout.component.scss'
})
export class HandsetLayoutComponent {

  public direction: MenuDirections = MenuDirections.Horizontal;
  public menuItems: MenuItem[] = handsetBottomMenuData;

}
